import myAvaliableTypes from './myAvaliableTypes'

export const getLoads = payload => ({
  type: myAvaliableTypes.GET_LOADS,
  payload
})

export const getLoadSuccess = payload => ({
  type: myAvaliableTypes.GET_LOADS_SUCCESS,
  payload
})

export const getLoadFailure = payload => ({
  type: myAvaliableTypes.GET_LOADS_FAILURE,
  payload
})

export const clearLoads = () => ({
  type: myAvaliableTypes.CLEAR_LOADS
})

export const markFavorite = payload => ({
  type: myAvaliableTypes.MARK_FAVORITE,
  payload
})

export const markFavoriteSuccess = payload => ({
  type: myAvaliableTypes.MARK_FAVORITE_SUCCESS,
  payload
})

export const markFavoriteFailure = payload => ({
  type: myAvaliableTypes.MARK_FAVORITE_FAILURE,
  payload
})

export const setFilters = payload => ({
  type: myAvaliableTypes.SET_FILTERS,
  payload
})

export const searchByMovementNumber = payload => ({
  type: myAvaliableTypes.SEARCH_BY_MOVEMENT_NUMBER,
  payload
})

export const loadMore = payload => ({
  type: myAvaliableTypes.LOAD_MORE,
  payload
})
